import axios from "axios";
import React, { useState, useEffect, useContext } from "react";
import { ConfigContext } from "../Context/ConfigContext";
import ExcelJS from 'exceljs';
import "./login.css";

const Temp = () => {

    const { apiB2BURL } = useContext(ConfigContext);

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get(`${apiB2BURL}/Customer/Parts/GetAllCategories?pc_id=&lang=en`);
                setCategories(response.data.data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        fetchCategories();
    }, [apiB2BURL]);

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Categories');

        // Add headers
        worksheet.columns = [
            { header: 'SR NO.', key: 'srno', width: 10 },
            { header: 'GROUP', key: 'group', width: 30 },
            { header: 'GROUP ARABIC', key: 'group_ar', width: 30 },
            { header: 'GROUP IMG', key: 'group_img', width: 15 },
            { header: 'DEPARTMENT', key: 'department', width: 30 },
            { header: 'DEPARTMENT ARABIC', key: 'department_ar', width: 30 },
            { header: 'DEPARTMENT IMG', key: 'department_img', width: 15 },
            { header: 'SUB DEPARTMENT', key: 'subdepartment', width: 30 },
            { header: 'SUB DEPARTMENT ARABIC', key: 'subdepartment_ar', width: 30 },
            { header: 'SUB DEPARTMENT IMG', key: 'subdepartment_img', width: 15 }
        ];

        // Add rows
        for (let i = 0; i < categories.length; i++) {
            const row = categories[i];
            const rowData = {
                srno: i + 1,
                group: row.STR_LEVEL === 1 ? row.STR_NODE_NAME : '',
                group_ar: row.STR_LEVEL === 1 ? row.STR_NODE_NAME_AR : '',
                department: row.STR_LEVEL === 2 ? row.STR_NODE_NAME : '',
                department_ar: row.STR_LEVEL === 2 ? row.STR_NODE_NAME_AR : '',
                subdepartment: row.STR_LEVEL === 3 || row.STR_LEVEL === 4 ? row.STR_NODE_NAME : '',
                subdepartment_ar: row.STR_LEVEL === 3 || row.STR_LEVEL === 4 ? row.STR_NODE_NAME_AR : ''
            };

            const excelRow = worksheet.addRow(rowData);

            // Add images - modified image handling
            try {
                if (row.STR_LEVEL === 1 || row.STR_LEVEL === 2 || row.STR_LEVEL === 3 || row.STR_LEVEL === 4) {
                    const response = await axios.get(
                        `https://dcapi.carz7.com/category-images/600x600/${row.STR_ID}`,
                        { responseType: 'arraybuffer' }
                    );

                    // Convert ArrayBuffer to Uint8Array
                    const imageBuffer = new Uint8Array(response.data);

                    const imageId = workbook.addImage({
                        buffer: imageBuffer,
                        extension: 'jpeg',
                    });

                    // Determine column based on level , note 3 and 4 share same column


                    const imageColumn = row.STR_LEVEL === 1 ? 3 :
                        row.STR_LEVEL === 2 ? 6 : 9;

                    worksheet.addImage(imageId, {
                        tl: { col: imageColumn, row: excelRow.number - 1 },
                        ext: { width: 50, height: 50 }
                    });
                }
            } catch (error) {
                console.error(`Error adding image for row ${i + 1}:`, error);
            }
        }

        // Save Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'categories.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <div className="login-container-login">
            <div className="mb-3">
                <button
                    className="btn btn-primary"
                    onClick={exportToExcel}
                >
                    Export to Excel
                </button>
            </div>
            <table className="table table-bordered">
                <tr>
                    <th>SR NO.</th>
                    <th>GROUP IMG</th>
                    <th>GROUP</th>
                    <th>GROUP ARABIC</th>
                    <th>DEPARTMENT IMG</th>
                    <th>DEPARTMENT</th>
                    <th>DEPARTMENT ARABIC</th>
                    <th>SUB DEPARTMENT IMG</th>
                    <th>SUB DEPARTMENT</th>
                    <th>SUB DEPARTMENT ARABIC</th>
                </tr>
                {
                    categories.map((row, index) => {
                        return <tr>
                            <td>{index + 1}</td>
                            <td>
                                {row.STR_LEVEL === 1 ? <img src={`https://dcapi.carz7.com/category-images/600x600/${row.STR_ID}`} style={{ width: '50px', height: '50px' }} /> : ""}
                            </td>
                            <td>{row.STR_LEVEL === 1 ? row.STR_NODE_NAME : ""}</td>
                            <td>{row.STR_LEVEL === 1 ? row.STR_NODE_NAME_AR : ""}</td>
                            <td>
                                {row.STR_LEVEL === 2 ? <img src={`https://dcapi.carz7.com/category-images/600x600/${row.STR_ID}`} style={{ width: '50px', height: '50px' }} /> : ""}
                            </td>
                            <td>{row.STR_LEVEL === 2 ? row.STR_NODE_NAME : ""}</td>
                            <td>{row.STR_LEVEL === 2 ? row.STR_NODE_NAME_AR : ""}</td>
                            <td>
                                {row.STR_LEVEL === 3 || row.STR_LEVEL === 4 ? <img src={`https://dcapi.carz7.com/category-images/600x600/${row.STR_ID}`} style={{ width: '50px', height: '50px' }} /> : ""}
                            </td>
                            <td>{row.STR_LEVEL === 3 || row.STR_LEVEL === 4 ? row.STR_NODE_NAME : ""}</td>
                            <td>{row.STR_LEVEL === 3 || row.STR_LEVEL === 4 ? row.STR_NODE_NAME_AR : ""}</td>
                        </tr>
                    })
                }
            </table>
        </div>
    );
}
export default Temp;